import React, { createContext, useState } from "react";
import { LoadingScreen } from "@components";

const UIContext = createContext();

const UIProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  const contextValue = {
    isLoading,
    setIsLoading,
  };

  return (
    <UIContext.Provider value={contextValue}>
      {children}
      {isLoading && <LoadingScreen />}
    </UIContext.Provider>
  );
};

export default UIContext;
export { UIProvider };
